export * from '@ckeditor/ckeditor5-basic-styles'
